// ContractsTable
import React from "react";
import Loader from 'components/Common/Loader';
import { Table } from 'antd';

// Zustand store
import { useShallow } from 'zustand/react/shallow';
import { useOutStaff, useContractsStore } from 'storeZustand';

import { useContractTableColumns } from 'hooks';

const ContractsTable = ({ setIsEdit, toggleModal }) => {
	// файлы клиента
	const [
		clearUploadFilesList // очистить список загруженных файлов
	] = useOutStaff(useShallow((state) => [
		state.clearUploadFilesList
	]));

	// Договоры клиента
	const [
		contractsList, // список договоров
		getContractById,
		loading
	] = useContractsStore(useShallow((state) => [
		state.contractsList,
		state.getContractById,
		state.loading
	]));

	// Информация о конкретном договоре клиента
	const handleCellClick = (id) => {
		getContractById(id);
		setIsEdit(true);
		toggleModal();
	};

	const columns = useContractTableColumns(handleCellClick);

	return (
		<>
			{loading && <Loader />}
			{!loading && contractsList && contractsList?.length > 0 && (
				<Table
					columns={columns}
					dataSource={contractsList}
					size='small'
					className='archi__table'
					rowKey="id"
				/>
			)}
		</>
	)
}

export default ContractsTable;